import React, { useRef, useEffect, useState } from 'react';

const MyComponent = ({ group, editedId }) => {
  const inputRef = useRef(null);
  const [overflow, setOverflow] = useState(false);

  useEffect(() => {
    const checkOverflow = () => {
      const input = inputRef.current;
      if (input && group.task) {
        // Use requestAnimationFrame to ensure DOM is fully rendered
        requestAnimationFrame(() => {
          if (input) {
            // Check if text is actually overflowing
            // Add a small buffer (1px) to account for rounding differences
            const isTextOverflowing = input.scrollWidth > input.clientWidth + 1;
            setOverflow(isTextOverflowing);
          }
        });
      } else {
        setOverflow(false);
      }
    };

    // Small delay to ensure DOM is ready
    const timeoutId = setTimeout(checkOverflow, 0);

    // Also check on window resize
    window.addEventListener('resize', checkOverflow);
    
    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener('resize', checkOverflow);
    };
  }, [group.task, editedId]);

  return (
    <>
      {overflow && (
        <span className="tooltip-tracker testq">{group.task}</span>
      )}
      <input
        type="text"
        name="task"
        autoComplete="off"
        title={overflow ? group.task : undefined}
        style={{ textOverflow: 'ellipsis', cursor: 'pointer', caretColor: 'transparent', overflow: 'hidden', whiteSpace: 'nowrap' }}
        value={group.task || ''}
        placeholder="Regular Input"
        className={group._id === editedId ? '' : ''}
        readOnly
        ref={inputRef}
      />
    </>
  );
};

export default MyComponent;
